import { MaterialCommunityIcons } from '@expo/vector-icons';
import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { Colors, NavigationButton } from '@gripp/shared-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMenuPermission } from '../hooks/useMenuPermision';
import { MenuOld } from './menu-old';
import { IMenu } from './menuItems';
import { WorkspacesUser } from './workspacesUser';

export const Menu = () => {
  // TODO: Crop Circle Redesign | Feature Flag can be removed after the release
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  // TODO: Crop Circle Redesign | Removed after the release
  if (!isCropCircleRedesignEnabled) {
    return <MenuOld />;
  }
  
  // TODO: Crop Circle Redesign | Remove MenuBase after the release
  return <MenuBase />;
}

export const MenuBase = () => {
  const { t } = useTranslation();
  const menuList = useMenuPermission()();
  const navigate = useNavigate();
  const location = useLocation();

  const isActiveRoute = (route: string) => {
    return location.pathname.includes(route);
  }

  const renderMenuItem = (link: IMenu, index: number) => {
    if (link.component) {
      return (
        <View key={index} style={{ marginVertical: 4 }}>
          <link.component {...link} />
        </View>
      );
    }
    
    return (
      <View key={index} style={{ marginVertical: 4 }}>
        <NavigationButton 
          key={index} 
          icon={link.icon}
          text={t(link.titleKey)} 
          active={isActiveRoute(link.route)} 
          showIcon={true} 
          showText={true} 
          mode="light"
          onPress={() => navigate(link.route)} 
        />
      </View>
    )
  };

  return (
    <View style={styles.container}>
      <View style={styles.topSection}>
        {/* Company Selector */}
        <View style={styles.companySelector}>
          <View style={styles.companySelectorContent}>
            <MaterialCommunityIcons 
              name="office-building" 
              size={20} 
              color={Colors.grayText} 
              style={{ marginRight: 8 }}
            />
            <WorkspacesUser />
          </View>
        </View>
        
        <View style={styles.menuList}>
          <View>
            {menuList.map((group, gdx) => {
              // Skip the last group (Account) as it will be rendered separately
              if (gdx === menuList.length - 1) return null;
              
              return group?.map((link: IMenu, index: number) => {
                return renderMenuItem(link, index);
              });
            })}
          </View>
        </View>
      
        <View style={styles.bottomSection}>
          {
            menuList[menuList.length - 1]?.map((link: IMenu, index: number) => { 
              return renderMenuItem(link, index);
            })
          }
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: Colors.primaryGrayBackground,
    width: 160,
  },
  topSection: {
    flex: 1,
    width: '100%',
  },
  bottomSection: {
    width: '100%',
    alignItems: 'center',
    position: 'absolute',
    bottom: 20,
  },
  companySelector: {
    paddingVertical: 16,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E9ECEF',
  },
  companySelectorContent: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 12,
  },
  companySelectorText: {
    fontSize: 14,
    fontWeight: '500',
    color: Colors.grayText,
    marginLeft: 8,
    marginRight: 'auto',
  },
  menuList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '80%',
    justifyContent: 'center',
    padding: 16,
    gap: 4,
  },
});
